'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/9/24.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import ReactPaginate from 'react-paginate';
// import ReactPaginate from '../Paginate/Paginate';

var HomeMiddleNav = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HomeMiddleNav, _Component);

  function HomeMiddleNav() {
    (0, _classCallCheck3.default)(this, HomeMiddleNav);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(HomeMiddleNav).apply(this, arguments));
  }

  (0, _createClass3.default)(HomeMiddleNav, [{
    key: 'onItemClick',
    value: function onItemClick(filterItem) {
      var filter = this.props.filter;

      if (filter) {
        filter(filterItem);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./HomeMiddleNav.scss');
      var info = this.props.info;

      return _react2.default.createElement(
        'div',
        { className: styles.component },
        info instanceof Array ? info.map(function (item, index) {
          var style = {};
          if (index % 3 === 2) {
            style = { marginRight: 0 };
          }
          return _react2.default.createElement(
            'div',
            { key: index, style: style, className: styles.item, onClick: function onClick() {
                return _this2.onItemClick(item.id);
              } },
            _react2.default.createElement('img', { src: item.src })
          );
        }) : ''
      );
    }
  }]);
  return HomeMiddleNav;
}(_react.Component), _class.propTypes = {
  info: _react.PropTypes.array.isRequired,
  filter: _react.PropTypes.func
}, _temp);
exports.default = HomeMiddleNav;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/HomeMiddleNav/HomeMiddleNav.js
 ** module id = 1353
 ** module chunks = 0
 **/